import { ref } from "vue";
import { goSolidApi } from "./useGoSolidApi";
import { ProjectionsByTechnology } from "@/types/projections";
import {
  createEmptyProjections,
  parseProjectionsFromApi,
} from "@/utils/projections";

interface UseProjectionsOptions {
  onError?: (error: unknown) => void;
}

/**
 * Composable for fetching and managing projections for a company
 */
export function useProjections(options?: UseProjectionsOptions) {
  const projections = ref<ProjectionsByTechnology>(createEmptyProjections());
  /**
   * Fetch projections for a company
   * @param companyId - The company ID to fetch projections for
   */
  const fetchProjections = async (companyId?: number | null) => {
    try {
      const response = await goSolidApi.get(
        `/api/company/${companyId}/projection`
      );

      projections.value = parseProjectionsFromApi(response.data.projection);
    } catch (error) {
      if (options?.onError) {
        options.onError(error);
      } else {
        console.error("Error fetching projections:", error);
      }
    }
  };

  return {
    projections,
    fetchProjections,
  };
}
